<mat-progress-bar *ngIf="loading" mode="indeterminate" />
<mat-card class="cardWithShadow m-b-48">

    <!-- Skeleton -->
    <div *ngIf="loading" class="p-32">
        <ngx-skeleton-loader count="8" [theme]="{height: '30px'}" />
    </div>

    <mat-card-header></mat-card-header>
    <mat-card-content *ngIf="!loading">
        <form class="m-y-10" [formGroup]="form" (ngSubmit)="onSubmit()">
            <mat-card-title class="m-b-10">Dati anagrafici</mat-card-title>
            <div class="form-group d-flex gap-10">
                <!-- Name -->
                <div style="width: 50%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Nome*</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="text" formControlName="name" />
                        <mat-hint *ngIf="f['name'].touched && f['name'].invalid" class="m-b-16 error-msg">
                            <div class="text-error" *ngIf="f['name'].errors && f['name'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>

                <!-- User Email -->
                <div style="width: 50%;" *ngIf="type === 'add'">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">User email*</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="email" formControlName="email" />
                        <mat-hint *ngIf="f['email'].touched && f['email'].invalid" class="m-b-16 error-msg">
                            <div class="text-error" *ngIf="f['email'].errors && f['email'].errors['required']">
                                Campo obbligatorio
                            </div>
                            <div class="text-error" *ngIf="f['email'].errors && f['email'].errors['email']">
                                Email non valida
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-group d-flex gap-10">
                <!-- Address -->
                <div style="width: 50%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Indirizzo</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="text" formControlName="address" class="w-100" />
                    </mat-form-field>
                </div>

                <div style="width: 10%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Civico</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="text" formControlName="civic" class="w-100" />
                    </mat-form-field>
                </div>

                <div style="width: 10%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">CAP</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="text" formControlName="cap" class="w-100" />
                    </mat-form-field>
                </div>

                <div style="width: 20%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Citt&agrave;</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="text" formControlName="city" class="w-100" />
                    </mat-form-field>
                </div>

                <div style="width: 10%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Provincia</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="text" formControlName="province" class="w-100" />
                    </mat-form-field>
                </div>
            </div>

            <!-- Coordinate -->
            <div class="form-group d-flex gap-10">
                <!-- Latitudine -->
                <div style="width: 25%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Latitudine</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="text" formControlName="latitude" class="w-100" />
                    </mat-form-field>
                </div>

                <!-- Longitudine -->
                <div style="width: 25%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Longitudine</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="text" formControlName="longitude" class="w-100" />
                    </mat-form-field>
                </div>
            </div>

            <!-- INFORMAZIONI AGGIUNTIVE -->
            <mat-card-title class="m-y-10">Informazioni aggiuntive</mat-card-title>
            <div class="form-group d-flex gap-10">

                <!-- Activation date -->
                <div style="width: 50%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Data attivazione*</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="date" formControlName="siteActivation" />
                        <mat-hint *ngIf="f['siteActivation'].touched && f['siteActivation'].invalid"
                            class="m-b-16 error-msg">
                            <div class="text-error"
                                *ngIf="f['siteActivation'].errors && f['siteActivation'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>

                <!-- Tipologia -->
                <!-- <div style="width: 50%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Tipologia*</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-select placeholder="Seleziona un tipo sito" formControlName="consumerProfile">
                            <mat-option value="Residenziale">Residenziale</mat-option>
                            <mat-option value="Ufficio">Ufficio</mat-option>
                            <mat-option value="Industria">Industria</mat-option>
                        </mat-select>
                        <mat-hint *ngIf="f['consumerProfile'].touched && f['consumerProfile'].invalid" class="m-b-16 error-msg">
                            <div class="text-error" *ngIf="f['consumerProfile'].errors && f['consumerProfile'].errors['required']">
                                Campo obbligatorio*
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>       -->

                <!-- Tipo Site -->
                <div style="width: 50%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Tipo sito*</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-label>Tipo di site</mat-label>
                        <mat-select matInput type="text" formControlName="type">
                            <mat-option *ngFor="let option of siteTypes" [value]="option.id"
                                (click)="setFormProfiles(option.id)">
                                {{ option.description }}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="f['type'].touched && f['type'].invalid" class="m-b-16 error-msg">
                            <div class="text-error" *ngIf="f['type'].errors && f['type'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>


                <!-- Cer -->
                <div style="width: 50%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Cer di appartenenza*</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-label>CER di appartenenza</mat-label>
                        <mat-select matInput type="text" formControlName="cer">
                            <mat-option *ngFor="let option of cerList" [value]="option.id">
                                {{ option.description }}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="f['cer'].touched && f['cer'].invalid" class="m-b-16 error-msg">
                            <div class="text-error" *ngIf="f['cer'].errors && f['cer'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-group d-flex gap-10">

                <!-- System Activation date -->
                <div style="width: 50%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Data attivazione
                        impianto*</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <input matInput type="date" formControlName="systemActivation" />
                        <mat-hint *ngIf="f['systemActivation'].touched && f['systemActivation'].invalid"
                            class="m-b-16 error-msg">
                            <div class="text-error"
                                *ngIf="f['systemActivation'].errors && f['systemActivation'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>


                <!-- Potenza consumo -->
                <div style="width: 25%;" *ngIf="f['type'].value === 'PROSUMER' || f['type'].value === 'CONSUMER'">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Potenza impianto di
                        consumo</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-label>Potenza impianto di consumo</mat-label>
                        <input matInput type="text" formControlName="max_consumption">
                        <mat-hint *ngIf="f['max_consumption'].touched && f['max_consumption'].invalid"
                            class="m-b-16 error-msg">
                            <div class="text-error"
                                *ngIf="f['max_consumption'].errors && f['max_consumption'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>

                <!-- Potenza produzione -->
                <div style="width: 25%;" *ngIf="f['type'].value === 'PROSUMER' || f['type'].value === 'PRODUCER'">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Potenza impianto di
                        produzione</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-label>Potenza impianto di produzione</mat-label>
                        <input matInput type="text" formControlName="max_production">
                        <mat-hint *ngIf="f['max_production'].touched && f['max_production'].invalid"
                            class="m-b-16 error-msg">
                            <div class="text-error"
                                *ngIf="f['max_production'].errors && f['max_production'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>



                <!-- Impianto con fondi 40% -->
                <div style="width: 50%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Impianto costruito con fondi
                        40%</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-label>Impianto costruito con fondi 40%</mat-label>
                        <mat-select matInput formControlName="incentive">
                            <mat-option [value]="'NO'">
                                No
                            </mat-option>
                            <mat-option [value]="'SI'">
                                Si
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="f['incentive'].touched && f['incentive'].invalid" class="m-b-16 error-msg">
                            <div class="text-error" *ngIf="f['incentive'].errors && f['incentive'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="form-group d-flex gap-10">
                <!-- Regions -->
                <div style="width: 33%;">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Regione GSE</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-label>Regione GSE</mat-label>
                        <mat-select matInput type="text" formControlName="region">
                            <mat-option *ngFor="let option of regions" [value]="option.id">
                                {{option.id}}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="f['region'].touched && f['region'].invalid" class="m-b-16 error-msg">
                            <div class="text-error" *ngIf="f['region'].errors && f['region'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>

                <!-- Profilo di consumo -->
                <div style="width: 33%;" *ngIf="f['type'].value === 'PROSUMER' || f['type'].value === 'CONSUMER'">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Profilo di consumo</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-label>Profilo di consumo</mat-label>
                        <mat-select matInput type="text" formControlName="consumerProfile">
                            <mat-option>Seleziona un valore</mat-option>
                            <mat-option *ngFor="let option of consumptionProfiles" [value]="option.id">
                                {{ option.description }}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="f['consumerProfile'].touched && f['consumerProfile'].invalid"
                            class="m-b-16 error-msg">
                            <div class="text-error"
                                *ngIf="f['consumerProfile'].errors && f['consumerProfile'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>

                <!-- Profilo di produzione -->
                <div style="width: 33%;" *ngIf="f['type'].value === 'PROSUMER' || f['type'].value === 'PRODUCER'">
                    <mat-label class="mat-subtitle-2 f-s-14 f-w-600 m-b-12 d-block">Profilo di produzione</mat-label>
                    <mat-form-field appearance="outline" class="w-100" color="primary">
                        <mat-label>Profilo di produzione</mat-label>
                        <mat-select matInput type="text" formControlName="productionProfile">
                            <mat-option>Seleziona un valore</mat-option>
                            <mat-option *ngFor="let option of productionProfiles" [value]="option.id">
                                {{ option.description }}
                            </mat-option>
                        </mat-select>
                        <mat-hint *ngIf="f['productionProfile'].touched && f['productionProfile'].invalid"
                            class="m-b-16 error-msg">
                            <div class="text-error"
                                *ngIf="f['productionProfile'].errors && f['productionProfile'].errors['required']">
                                Campo obbligatorio
                            </div>
                        </mat-hint>
                    </mat-form-field>
                </div>
            </div>

            <div class="row w-100 text-center">
                <button mat-flat-button color="primary" class="w-15 m-x-auto " [disabled]="!form.valid">
                    Inserisci sito
                </button>
            </div>
        </form>

    </mat-card-content>
</mat-card>